import { useState, useEffect } from 'react';
import { createCallStatus,
      updateCallStatus,
      deleteCallStatus,
      getCallStatus, } from 'services/callStatus';


// Hook for Creating Call Status
export const useCreateCallStatus = () => {
  const [loading, setLoading] = useState(false);  
  const [error, setError] = useState(null);

  const create = async (data) => {
    setLoading(true);
    setError(null);
    try {
      const response = await createCallStatus(data);
      setLoading(false);
      return response;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  return { create, loading, error };
};

// Hook for Updating Call Status
export const useUpdateCallStatus = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const update = async (userId, data) => {
    setLoading(true);
    setError(null);
    try {
      const response = await updateCallStatus(userId, data);
      setLoading(false);
      return response;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  return { update, loading, error };
};

// Hook for Deleting Call Status
export const useDeleteCallStatus = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const remove = async (userId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await deleteCallStatus(userId);
      setLoading(false);
      return response;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  return { remove, loading, error };
};

// Hook for Fetching Call Status
export const useGetCallStatus = (userId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStatus = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getCallStatus(userId);
        setData(response.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchStatus();
  }, [userId]);

  return { data, loading, error };
};